export const ACTION = {
  GET_LIST: "GET_LIST"
};

export const CONST = {};
